@if (processing) {
  <mat-spinner [color]="color" diameter="16"/>
}

<div class="svc-filled-btn-content">
  <ng-content/>
</div>